export default __webpack_public_path__ + "static/media/ramsubbamma@2x.af12c612.png";